import axios from "axios";
import AuthService from "./authService";
const USER_API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const BASE_ROUTE = "/api/v1/teams";

class TeamService {
  static async getMyTeams() {
    return axios.get(
      `${USER_API_BASE_URL}${BASE_ROUTE}/`,
      this.getAuthHeader()
    );
  }

  /**
   *
   * @returns Only designers and admin will be allowed to get all teams
   */
  static async getAllTeams() {
    return axios.get(
      `${USER_API_BASE_URL}${BASE_ROUTE}/all`,
      this.getAuthHeader()
    );
  }

  static async createTeam(data) {
    const res = await axios.post(
      `${USER_API_BASE_URL}${BASE_ROUTE}/team`,
      data,
      this.getAuthHeader()
    );

    const {
      data: {
        data: { id },
        status,
      },
    } = res;

    if (status === "success" && id) {
      window.analytics.track("Team Created");
    }

    return res;
  }

  static async deleteTeam(data) {
    return axios.delete(
      `${USER_API_BASE_URL}${BASE_ROUTE}/team/${data.id}`,
      this.getAuthHeader()
    );
  }

  static async renameTeam(data) {
    return axios.put(
      `${USER_API_BASE_URL}${BASE_ROUTE}/team/name`,
      data,
      this.getAuthHeader()
    );
  }

  static async removeTeammate(data) {
    return axios.delete(
      `${USER_API_BASE_URL}${BASE_ROUTE}/team/${data.teamId}/member/${data.teammateId}`,
      this.getAuthHeader()
    );
  }

  static async getInviteLink(teamId) {
    return axios.get(
      `${USER_API_BASE_URL}${BASE_ROUTE}/team/link?teamId=${teamId}`,
      this.getAuthHeader()
    );
  }

  static async getTokenInfo(token) {
    return axios.get(
      `${USER_API_BASE_URL}${BASE_ROUTE}/tokenInfo?token=${token}`
    );
  }

  static async joinUserToTeamWithInviteToken(token) {
    return axios.post(
      `${USER_API_BASE_URL}${BASE_ROUTE}/join`,
      { token },
      this.getAuthHeader()
    );
  }

  static getAuthHeader() {
    return { headers: { "x-access-token": AuthService.getJWT() } };
  }
}

export default TeamService;
